import { createContext, useContext } from 'react';

export interface DemoTourContextValue {
  isActive: boolean;
  currentStep: number;
  totalSteps: number;
  startTour: () => void;
  stopTour: () => void;
}

export const DemoTourContext = createContext<DemoTourContextValue>({
  isActive: false,
  currentStep: 0,
  totalSteps: 0,
  startTour: () => {},
  stopTour: () => {},
});

export function useDemoTour() {
  return useContext(DemoTourContext);
}
